import { render } from "./VdbHeader.vue?vue&type=template&id=5b82ac19&scoped=true"
import script from "./VdbHeader.vue?vue&type=script&lang=js"
export * from "./VdbHeader.vue?vue&type=script&lang=js"

import "./VdbHeader.vue?vue&type=style&index=0&id=5b82ac19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b82ac19"]])

export default __exports__